import { ClienteServiceAdapter } from '@/usecases'
import { create, update, find, get, importaItens, findClienteComCashback, validarClubeDoCliente } from '@/api/cliente'
import { ClienteDaImportacaoCSV, FormCliente, FormVoucher, Page, Voucher } from '@/models'
import { AxiosRequestConfig } from 'axios'
import request from '@/common/request'

const PATH = '/clientes'

export class ClienteService implements ClienteServiceAdapter {
	create = async (cliente: FormCliente) => await create(cliente)
	update = async (cliente: FormCliente) => await update(cliente)
	get = async (id: string) => await get(id)
	find = async (params?: any, config?: AxiosRequestConfig) => await find(params, config)
	findClienteComCashback = async (params?: any, config?: AxiosRequestConfig) => await findClienteComCashback(params, config)

	async getVouchers(clienteId: string, params?: any, config?: AxiosRequestConfig): Promise<Page<Voucher>> {
		return request.get(`${PATH}/${clienteId}/vouchers`, {
			params,
			...config,
		})
	}

	async addVoucher(voucher: FormVoucher): Promise<Voucher> {
		return request.post(`${PATH}/${voucher.clienteId}/vouchers`, voucher)
	}

	importaItens = async(items: ClienteDaImportacaoCSV[]) =>
		await importaItens(items)

	validarClubeDoCliente = async (cpfOuCnpjCliente: string) => await validarClubeDoCliente(cpfOuCnpjCliente)
}
